import React from 'react';
import { ScrollReveal } from './shared';

const LeadershipSection = () => {
  const leaders = [
    {
      name: 'Dr. R. Sukumar',
      role: 'Predictive Intelligence',
      image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/4o4g4d1s_Sukumar%20Headshot.png',
      bio: '',
      credentials: 'Creator of ASEMAP | OSG Analytics',
      initials: 'RS',
      imagePosition: 'center top',
      imageScale: 1.15,
      firmName: 'OSG Analytics',
      firmUrl: 'https://osganalytics.com',
    },
    {
      name: 'Erania Brackett',
      role: 'Strategic Integration & M&A Advisory',
      image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/pvn6eazu_Erania%20Head%20Shot_best.jpg',
      bio: '',
      credentials: 'Former Fortune 1000 C-suite | Brackett Partners',
      initials: 'EB',
      imagePosition: 'center 20%',
      imageScale: 1,
      imageBg: '#9ca3af',
      firmName: 'Brackett Partners',
      firmUrl: 'https://brackett.partners',
    },
    {
      name: 'Forest T. Harper Jr.',
      role: 'Growth Activation & Leadership Alignment',
      image: 'https://customer-assets.emergentagent.com/job_three-superpowers/artifacts/nhsnrfz3_Forest%20%283%20of%203%29.JPG',
      bio: '',
      credentials: '28 years Pfizer C-suite | Harper Cook Consulting',
      initials: 'FH',
      imagePosition: 'center top',
      imageScale: 1,
      firmName: 'Harper Cook Consulting',
      firmUrl: 'https://harpercookconsultingllc.com',
    },
  ];

  return (
    <section id="leadership" className="section-spacing bg-[#F1F5F9]" data-testid="leadership-section">
      <div className="container-luxury">
        <ScrollReveal>
          <div className="max-w-3xl mx-auto text-center mb-16">
            <p className="overline mb-4">Leadership</p>
            <h2 className="heading-section text-4xl sm:text-5xl text-[#0B1A2B] mb-6" data-testid="leadership-headline">
              Senior leaders with complementary strengths.
            </h2>
          </div>
        </ScrollReveal>
        
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {leaders.map((leader, index) => (
            <ScrollReveal key={index} delay={index * 150}>
              <div className="text-center" data-testid={`leader-card-${index + 1}`}>
                <div className="leader-image-wrapper" style={leader.imageBg ? { backgroundColor: leader.imageBg } : {}}>
                  <img 
                    src={leader.image} 
                    alt={leader.name}
                    className="leader-image"
                    style={{ objectPosition: leader.imagePosition, transform: `scale(${leader.imageScale})`, transformOrigin: 'center top' }}
                    loading="lazy"
                    onError={(e) => {
                      e.target.parentElement.innerHTML = `<div class="w-full h-full bg-[#E2E8F0] flex items-center justify-center"><span class="text-4xl font-serif text-[#D97706]">${leader.initials}</span></div>`;
                    }}
                  />
                </div>
                <h3 className="font-serif text-xl text-[#0B1A2B] mb-1">{leader.name}</h3>
                <p className="text-[#D97706] text-sm font-medium mb-2">{leader.role}</p>
                {leader.bio && <p className="text-[#334155] text-[0.875rem] leading-relaxed mb-2">{leader.bio}</p>}
                <p className="text-[#64748B] text-xs leading-relaxed mb-3">{leader.credentials}</p>
                <a
                  href={leader.firmUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-sm font-medium text-[#0B1A2B] hover:text-[#D97706] transition-colors duration-300"
                  data-testid={`leader-firm-link-${index + 1}`}
                >
                  {leader.firmName}
                  <span className="ml-1.5 text-xs">↗</span>
                </a>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;
